import { FC, ReactNode } from 'react';

import { css } from '@emotion/react';
import { ToucanComponents, ButtonType } from '@jointoucan/toucan-design';
import { useTheme } from '@mui/material';

import { Box, BoxProps } from '~/components/shared/Box';

import { InformationHeader } from './InformationHeader';

const { Button } = ToucanComponents;

interface InformationProps extends BoxProps {
  header: string;
  information: string | ReactNode;
  informationMaxWidth?: number;
  subInformation?: string;
  buttonText?: string;
  buttonType?: ButtonType;
  onClickButton?: () => void;
  className?: string;
  isInformationStacked?: boolean;
  extraContent?: ReactNode;
}

const Information: FC<InformationProps> = ({
  header,
  information,
  informationMaxWidth,
  subInformation,
  buttonText,
  buttonType = 'text',
  onClickButton,
  className,
  isInformationStacked = false,
  extraContent,
  ...boxProps
}) => {
  const theme = useTheme();

  return (
    <Box
      className={className}
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      width="100%"
      css={css`
        ${theme.breakpoints.up('sm')} {
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        }
      `}
      {...boxProps}
    >
      <InformationHeader
        information={information}
        subInformation={subInformation}
        isStacked={isInformationStacked}
        maxWidth={informationMaxWidth}
      >
        {header}
      </InformationHeader>
      {extraContent ||
        (buttonText && onClickButton && (
          <Button
            type={buttonType}
            onClick={onClickButton}
            css={css`
              margin-top: ${theme.spacing(buttonType === 'text' ? 0.5 : 2)};
              ${theme.breakpoints.up('sm')} {
                margin-top: 0;
              }
            `}
          >
            {buttonText}
          </Button>
        ))}
    </Box>
  );
};

export default Information;
